import * as actionTypes from "../actions/actionTypes";
import { updateObject } from "../utility";

const initialState = {
  ongoingOrders: [],
  completedOrders: [],
  cancelledOrders: [],
  ongoingBtnLoading: false,
  completedBtnLoading: true,
  limit: 5,
  lastDoc: null,
  leadsexhausted: false,
  cancelOrderLoading: false,
  cancelBtnLoading: false,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.BOOKINGS_CONTROLS:
      return updateObject(state, action.payload);
    default:
      return state;
  }
};
export default reducer;
